module.exports = __webpack_public_path__ + "static/img/33.6bfcadb.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/AzureImplementation/33.png
// module id = 8omP
// module chunks = 1